<template>
  <div class="category" v-loading="loadingLocations">
    <h6>Выберите сотрудника</h6>
    <el-cascader
        class="cascade"
        v-model="category_first"
        :options="filteredOptions"
        @change="handleChange"
        placeholder="Выбрать сотрудников"
        :props="{
              multiple:false
            }"
        clearable
        filterable
    >
    </el-cascader>
  </div>

</template>

<script>


import login from "@/views/auth/Login.vue";

export default {
  name: "custom-cascader-employees",
  props: {
    multipart: {
      default: true
    },
    propsGetSelectedCategoryAndEmployee:{},
    categoryName: {},
    agentName: {}


  },
  data() {
    return {
      category_first: null,
      category_two: null,
      loadingLocations: true,
      locationsData: null,
      optionsCategoryTwo: [{value: 0, label: '1'}, {value: 1, label: '2'}],
      optionsCategoryFirst: [{value: 0, label: '1'}, {value: 1, label: '2'}],
      // options: [
      //   {
      //     label: 'locations',
      //     value: '1',
      //     children: [
      //       {
      //         label: 'sublocations',
      //         value: 2,
      //         children: [
      //           {
      //             label: 'categoryies',
      //             value: '1',
      //             children: [
      //               {
      //                 label: 'agents',
      //                 value: '1',
      //               }
      //             ]
      //           }
      //         ]
      //       }
      //     ]
      //   },
      // ],
      options: [
        {
          label: '',
          value: '1',
          children: [
            {
              label: '',
              value: '2',
            }
          ]
        },
      ]
    }
  },
  mounted() {
    this.getLocations()
  },
  methods: {
    getLocations() {
      this.loading = true;
      this.$api.location.getAgentsWithCategories()
          .then(data => {
            this.locationsData = data
          })
          .finally(() => {
            this.loadingLocations = false;
          })
    },
    handleChange(value) {
      let filteredCategory = []
      value.forEach(el => {
          filteredCategory.push([el[0], el[1]])
      })
      this.propsGetSelectedCategoryAndEmployee({
        employee:value[0],
        category:value[1],
        categoryName: this.getCategoryName(value)
      })
    },
    getCategoryName(value) {
      const agent = this.locationsData.find(item => item.agent_name === value[0])
      console.log(value)
      return agent.category.name
    }
  },
  computed: {
    filteredOptions() {
      let filteredOptions = []

      if (this.locationsData) {
        this.locationsData.forEach(agent => {
          let agentObj = {
            value: agent.agent_name,
            label: agent.agent_name,
            children: [{
              value: agent.category.id,
              label: agent.category.name
            }]
          }
          filteredOptions.push(agentObj)
        })
      }
      return filteredOptions
    }
  }
}
</script>

<style lang="scss" scoped>
h6 {
  font-size: 15px;
  margin-bottom: 0;
  color: #555;
}

::v-deep .el-input__inner {
  height: 30px;
}

::v-deep .el-input__icon {
  display: flex;
  align-items: center;
}

::v-deep .el-range-separator {
  display: flex;
  align-items: center;
}

::v-deep .el-range-input {
  width: 79%;
}

::v-deep .el-cascader {
  min-width: 250px;
  width: 100%;
}

::v-deep {
  .el-select {
    width: 100%;
  }
}

</style>